import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { ICementeriesFormData } from 'views/CementeriesView/components/CementeriesForm/types';
import { onGetOne, onSave } from 'redux/actions/cementeries.actions';
import { cementeriesFormSelector } from 'redux/selectors/cementeries.selector';

import LayoutContainer from 'containers/LayoutContainer';
import CementeriesForm from 'views/CementeriesView/components/CementeriesForm';
import Loading from 'components/commons/Loading';

import 'views/CementeriesView/components/CementeriesForm/i18n';

const CementeriesFormContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const initialValues = useTypedSelector(cementeriesFormSelector);
  const { loading } = useTypedSelector((state) => state.cementeries);
  const isEditing = !!id;

  useEffect(() => {
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  const onSubmit = (formData: ICementeriesFormData) => dispatch(onSave(formData, id));

  return (
    <LayoutContainer auth title={i18next.t<string>('CEMENTERIES_FORM:TITLE')}>
      <CementeriesForm initialValues={initialValues} isEditing={isEditing} onSubmit={onSubmit} />
      {loading && <Loading isModalMode message={i18next.t<string>('CEMENTERIES_FORM:LOADING')} />}
    </LayoutContainer>
  );
};

export default CementeriesFormContainer;
